import React, { useEffect, useRef } from 'react';
import useTerminal from './useTerminal';
import { isMobileTerminal } from '../../utils/isMobileTerminal';
import {
    NEOFETCH_BANNER,
    NEOFETCH_BANNER_MOBILE,
    NEOFETCH_INFO
} from './neofetch';
import './terminal.css';

const Terminal = () => {
    const { lines, input } = useTerminal();
    const viewportRef = useRef(null);
    const isMobile = isMobileTerminal();

    
    useEffect(() => {
        if (!viewportRef.current) return;
        viewportRef.current.scrollTop =
            viewportRef.current.scrollHeight;
    }, [lines, input]);

    {}

    
    useEffect(() => {
        const glitchLines = document.querySelectorAll('.glitch-line');
        if (!glitchLines.length) return;

        
        const jitterInterval = setInterval(() => {
            const count = Math.floor(Math.random() * 6) + 2;
            for (let i = 0; i < count; i++) {
                const line = glitchLines[Math.floor(Math.random() * glitchLines.length)];
                line.classList.add('glitch-jitter');
                setTimeout(() => {
                    line.classList.remove('glitch-jitter');
                }, 180);
            }
        }, 900);


        const dissolveInterval = setInterval(() => {
            glitchLines.forEach(line => {
                const slice = Math.floor(Math.random() * 80);
                const shift = (Math.random() * 80 - 40) + 'px';

                line.style.setProperty('--slice', slice);
                line.style.setProperty('--shift', shift);

                line.classList.add('glitch-dissolve');
            });

            setTimeout(() => {
                glitchLines.forEach(line => {
                    line.classList.remove('glitch-dissolve');
                });
            }, 380);
        }, 7000 + Math.random() * 6000);


        return () => {
            clearInterval(jitterInterval);
            clearInterval(dissolveInterval);
        };
    }, []);

    return (
        <div className="terminal-root">
            <div
                className="terminal-viewport"
                ref={viewportRef}
                onClick={() => {
                    if (isMobile) {
                        const el = document.querySelector('.terminal-hidden-input');
                        el?.focus();
                    }
                }}
            >


            {}
                <div className="terminal-line header">
                    fetch.remotePortfolioService::443@khwahish.dev
                </div>

                {}
                {isMobile ? (
                    <>
                        <div className="neofetch-ascii">
                            {NEOFETCH_BANNER_MOBILE.map((l, i) => (
                                <div key={i} className="terminal-line glitch-line">
                                    {l}
                                </div>
                            ))}
                        </div>

                        <div className="neofetch-info">
                            {NEOFETCH_INFO.map(([k, v]) => (
                                <div key={k} className="terminal-line">
                                    <span className="label">{k}:</span>{" "}
                                    <span>{v}</span>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <div className="neofetch">
                        <div className="neofetch-ascii">
                            {NEOFETCH_BANNER.map((l, i) => (
                                <div key={i} className="terminal-line glitch-line">
                                    {l}
                                </div>
                            ))}
                        </div>

                        <div className="neofetch-info">
                            {NEOFETCH_INFO.map(([k, v]) => (
                                <div key={k} className="terminal-line">
                                    <span className="label">{k}:</span>{" "}
                                    <span>{v}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="terminal-line spacer" />

                {}
                {lines.map((line, i) => {
                    if (line.type === 'cmd') {
                        return (
                            <div key={i} className="terminal-line terminal-cmd">
                                {line.text}
                            </div>
                        );
                    }
                    if (line.type === 'out') {
                        return (
                            <div key={i} className="terminal-line terminal-out">
                                {line.text}
                            </div>
                        );
                    }
                    if (line.type === 'help-grid') {
                        return (
                            <div key={i} className="terminal-help-grid">
                                {line.items.map(cmd => {
                                    const isModeSwitch = cmd === 'hrmode';

                                    return (
                                        <div
                                            key={cmd}
                                            className={
                                                `terminal-help-item ${
                                                    isModeSwitch ? 'terminal-help-item--mode' : ''
                                                }`
                                            }
                                        >
                                            {cmd}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    }
                    if (line.type === 'spacer') {
                        return <div key={i} className="terminal-line spacer" />;
                    }
                    return null;
                })}

                {}
                <div className="terminal-line terminal-input">
                    <span className="prompt-user">visitor</span>
                    <span className="prompt-at">@</span>
                    <span className="prompt-host">khwahish.portfolio</span>
                    <span className="prompt-path">:~</span>
                    <span className="prompt-symbol">$</span>
                    <span> {input}</span>
                    <span className="terminal-cursor" />
                </div>
                {}
                <input
                    className="terminal-hidden-input"
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    inputMode="text"
                />


            </div>
        </div>
    );
};

export default Terminal;
